<div class="root">
  <div class="title">
    @if (mobile) {
      <app-icon-button (click)="back()" colorVariant="secondary-dark" icon="arrow_back" size="small"/>
    }
    <div class="typo-h2">{{ "appointmentSelection.dateSelection.title" | transloco }}</div>
  </div>
  <div class="body">
    <div class="month-selection">
      <app-icon-button (click)="changeMonth(-1)" colorVariant="transparent" icon="keyboard_arrow_left" size="big"/>

      <div class="body-text-bold">{{ appointmentSelectionService.monthForm.value | customDate:'LLLL yyyy' }}</div>

      <app-icon-button (click)="changeMonth(1)" colorVariant="transparent" icon="keyboard_arrow_right" size="big"/>
    </div>

    <div class="weekdays">
      @for (weekday of weekdays; track weekday) {
        <div class="weekday">{{ "days." + weekday | transloco }}</div>
      }
    </div>

    <div class="grid">
      @for (day of dayList; track day.toISODate()) {
        @switch (getDayState(day)) {
          @case ('hidden') {
            <div></div>
          }
          @case ('unavailable') {
            <div class="unavailable">{{ day.day }}</div>
          }
          @case ('today-unavailable') {
            <div class="today-unavailable">{{ day.day }}</div>
          }
          @case ('available') {
            <app-icon-button (click)="selectDay(day)" [number]="day.day" colorVariant="secondary" size="small"/>
          }
          @case ('today-available') {
            <app-icon-button (click)="selectDay(day)" [number]="day.day" colorVariant="secondary" size="small-border"/>
          }
          @case ('selected') {
            <app-icon-button (click)="selectDay(day)" [number]="day.day" colorVariant="primary" size="small"/>
          }
        }
      }
    </div>
  </div>
</div>
